import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { adsService } from "../services/adsService";
import type { AdAnalyticsSummary } from "../types";

/** Top-level performance aggregates + 30-day spend trend.
 *  `window=live` covers active/paused campaigns (the default view —
 *  "what's running and how is it doing"); `window=all_time` includes
 *  completed and cancelled for the lifetime picture. */
export function useAdAnalyticsSummary(
  clientId: string | undefined,
  window: "live" | "all_time" = "live"
): UseQueryResult<AdAnalyticsSummary> {
  return useQuery({
    queryKey: ["ads", "analytics-summary", clientId ?? "none", window],
    queryFn: () => adsService.getAnalyticsSummary(clientId!, window),
    enabled: !!clientId,
    staleTime: 30_000,
  });
}
